"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultValueFactory = void 0;
const assert_never_1 = __importDefault(require("assert-never"));
const enums_1 = require("../enums");
exports.DefaultValueFactory = {
    of(param) {
        const create = (action) => (Object.assign({ Name: enums_1.AlgorithmEnum.ValueFactory, Key: param.paramKey }, action));
        const isRoot = param.paramPath.length === 0;
        switch (param.paramType) {
            case enums_1.ParamTypeEnum.Quantity: {
                if (isRoot) {
                    return create({ Operator: enums_1.ValueSupplierEnum.Input });
                }
                return create({ Operator: enums_1.ValueSupplierEnum.Specified, Value: 1 });
            }
            case enums_1.ParamTypeEnum.Spec: {
                return create({ Operator: param.isRef ? enums_1.ValueSupplierEnum.System : enums_1.ValueSupplierEnum.Input });
            }
            case enums_1.ParamTypeEnum.ExternalParameter: {
                return create({ Operator: enums_1.ValueSupplierEnum.Input });
            }
            default: {
                (0, assert_never_1.default)(param.paramType);
            }
        }
    },
};
